<template>
  <div class="user-listing">
    <loading v-if="!users" />

    <div v-if="users">
      <user-table
        :users="users"
        :has_more="has_more"
        :loading="loading"
      ></user-table>
    </div>
  </div>
</template>

<script>
import UserTable from "@/components/user/UserTable.vue";
import adminApi from "@/api/admin";
import Loading from "@/components/shared/Loading.vue";
import { mapGetters } from "vuex";

export default {
  components: { UserTable, Loading },
  data() {
    return {
      search: "",
      loading: true,
      users: null,
      has_more: null,
    };
  },
  computed: {
    ...mapGetters(["user_details"]),
  },
  mounted() {
    // don't refresh filters unless the user_details are populated
    if (this.user_details && Object.keys(this.user_details).length > 0) {
      this.refresh_filters();
    }
  },
  watch: {
    $route() {
      this.refresh_filters();
    },
    user_details() {
      this.refresh_filters();
    },
  },
  methods: {
    refresh_filters() {
      this.loading = true;
      this.users = [];

      const account_id = this.$route.params.account_id;
      const page_id = this.$route.query.paging_id || "";
      const active_only = this.$route.query.active_only || true;
      this.$log.debug(
        `refreshing filters with the following parameeters: account_id=${account_id}, active_only=${active_only}, paging_id=${page_id}`
      );

      let filters = this.$route.query.filters || [];
      // filters list with one item returns a string, cast to array
      this.$route.query.filters =
        typeof filters == "string" ? [filters] : filters;
      filters = this.$route.query.filters;

      // build filters query for many filters
      let api_filters = "";
      for (let i = 0; i < filters.length; i++) {
        api_filters += `&filter=${filters[i]}`;
      }

      return adminApi
        .get_user_listing_page(account_id, page_id, active_only, api_filters)
        .then((response) => {
          this.users = response.data.data;
          this.has_more = response.data.has_more;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.users = [];
        });
    },
  },
};
</script>
